import Home from '@/components/home/home'
import Index from '@/components/index/index'
import Detail from '@/components/detail/detail'
import Sell from '@/components/sell/sell'
import Goods from '@/components/goods/goods'
import HotAcc from '@/components/hotAcc/hotAcc'
import SoldAcc from '@/components/soldAcc/soldAcc'
import EvaluateAcc from '@/components/evaluateAcc/evaluateAcc'
import RecoverAcc from '@/components/recoverAcc/recoverAcc'
import Message from '@/components/message/message'
import Help from '@/components/help/help'

import Login from '@/components/login/login'
import Regist from '@/components/regist/regist'

export default
  [
    {
      // 首页
      path: '',
      component: Home,
      meta: {title: '账号交易系统'},
      children: [
        {
          name: 'index',
          path: '',
          component: Index
        },
        // 出售大厅
        {
          name: 'goods',
          path: '/goods',
          component: Goods
        },
        // 热卖账号
        {
          name: 'hot-acc',
          path: '/hot-acc',
          component: HotAcc
        },
        // 已售账号
        {
          name: 'sold-acc',
          path: '/sold-acc',
          component: SoldAcc
        },
        // 账号评估
        {
          name: 'evaluate-acc',
          path: '/evaluate-acc',
          meta: {
            requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: EvaluateAcc
        },
        // 账号系统回收
        {
          name: 'recover-acc',
          path: '/recover-acc',
          meta: {
            requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: RecoverAcc
        },
        {
          // 登录
          name: 'login',
          path: '/login',
          component: Login
        },
        {
          // 注册
          name: 'register',
          path: '/register',
          component: Regist
        },
        {
          // 详细资料
          path: '/acc-detail/:id',
          name: 'acc-detail',
          component: Detail
        },
        {
          path: '/sell',
          name: 'sell',
          meta: {
            requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: Sell
        },
        {
          path: '/message',
          name: 'message',
          meta: {
            requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: Message
        },
        {
          path: '/help',
          name: 'help',
          component: Help
        }
      ]
    }
  ]




// WEBPACK FOOTER //
// ./src/router/index.js